// assets/section-header.js
// Handles two header behaviours, driven by data attributes on <store-header>:
//
// - data-transparent: keeps the header in normal flow (below the announcement
//   bar) while pulling the following section up underneath it via a negative
//   bottom margin == header height, so a hero shows through the transparent bar.
//
// - data-sticky: the section wrapper is position:sticky; top:0. If a *sticky*
//   announcement bar sits above it, the header's top is offset by that bar's
//   height so the two stack instead of overlapping. Recomputed on resize and
//   theme-editor events.
if (!customElements.get("store-header")) {
  customElements.define(
    "store-header",
    class StoreHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest(".shopify-section");
        this.update = this.update.bind(this);

        this.update();

        if ("ResizeObserver" in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this);
          // Also watch the announcement bar (its height drives the sticky offset).
          const announcement = document.querySelector(".announcement-bar");
          if (announcement) this.resizeObserver.observe(announcement);
        }
        window.addEventListener("resize", this.update);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener("resize", this.update);
        if (this.section) {
          this.section.style.marginBottom = "";
          this.section.style.top = "";
        }
      }

      update() {
        if (!this.section) return;

        // Transparent overlay: pull the next section up under the header.
        if (this.dataset.transparent === "true" && this.dataset.sticky !== "true") {
          this.section.style.marginBottom = `-${this.offsetHeight}px`;
        }

        // Sticky: offset below a sticky announcement bar so they don't overlap.
        if (this.dataset.sticky === "true") {
          this.section.style.top = `${this.stickyOffset()}px`;
        }
      }

      stickyOffset() {
        const announcement = document.querySelector(".announcement-bar");
        if (!announcement) return 0;
        const annSection = announcement.closest(".shopify-section");
        if (!annSection) return 0;
        // Only offset when the announcement bar is itself sticky/pinned.
        if (getComputedStyle(annSection).position !== "sticky") return 0;
        // Use the fractional rendered height (getBoundingClientRect), floored, so
        // the header sits flush/slightly under the bar instead of leaving a 1px
        // gap from offsetHeight's integer rounding.
        return Math.floor(annSection.getBoundingClientRect().height);
      }
    },
  );
}

document.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("store-header").forEach((el) => el.update?.());
});
